import { useSelector } from 'react-redux';

import { Tooltip } from 'components/Tooltip/Tooltip';
import { ReactComponent as InfoIcon } from 'icons/ico-info-current-color.svg';
import { selectFirstOfferInstallments } from 'selectors/entities/recurringOffers/recurringOffers';
import { getCardinalNumber } from 'utils/date/date';
import { useTranslations } from 'utils/translations/useTranslations';

type RecurringLabelsProps = {
  interval: number;
  chargeDay?: number;
};

function RecurringLabels({ interval, chargeDay }: RecurringLabelsProps) {
  const i18n = useTranslations();
  const instalments = useSelector(selectFirstOfferInstallments);

  const instalmentsWithSameAmount = !!(
    instalments?.length &&
    instalments?.every(
      instalment => instalment.amount === instalments[0].amount,
    )
  );

  const intervalText = instalmentsWithSameAmount
    ? i18n.t('paymentOptions.recurringPayment.interval', {
        interval: `${interval}`,
      })
    : i18n.t('paymentOptions.recurringPayment.firstInstalment');

  return (
    <span>
      {intervalText}
      {chargeDay && (
        <>
          {', '}
          <span className="Offer-recurringPayment-chargeDay">
            {i18n.t('paymentOptions.recurringPayment.chargedDate', {
              chargeDayOrdinal: `${getCardinalNumber(
                chargeDay,
                i18n.currentLocale,
              )}`,
              chargeDay: `${chargeDay}`,
            })}
            <Tooltip
              className="bg-transparent"
              defaultMessage={
                i18n.t(
                  'paymentOptions.recurringPayment.chargedDate.tooltip',
                ) as string
              }
            >
              <InfoIcon
                height="12"
                width="12"
                className="marginRight-xs"
                aria-hidden="true"
              />
            </Tooltip>
          </span>
        </>
      )}
    </span>
  );
}

export { RecurringLabels };
